export const free_spin_status_bar = (t) => ({
	FREE_SPIN_LEFT: {
		value: 'FREE ROUNDS LEFT ',
		config: {
			fill: '#F2F3FD',
			fontFamily: 'Poppins SemiBold',
			fontSize: 22
		}
	},
	FREE_SPIN_LEFT_AMOUNT: {
		value: '1000',
		config: {
			fill: ['#92CF25', '#225A0F'],
			fontFamily: 'Poppins SemiBold',
			fontSize: 22
		}
	},
	FREE_SPIN_WIN: {
		value: t('bonus.total_win'),
		config: {
			fill: '#F2F3FD',
			fontFamily: 'Poppins SemiBold',
			fontSize: 22
		}
	},
	FREE_SPIN_WIN_AMOUNT: {
		value: '$100.00',
		config: {
			fill: ['#92CF25', '#225A0F'],
			fontFamily: 'Poppins SemiBold',
			fontSize: 22
		}
	}
});
